import { z } from 'zod';
const annotationStatusEnum = z.enum(['not_started', 'uploaded', 'processing', 'in_review', 'done', 'error', 'skipped']);
export const annotationResponseModel = z.object({
    id: z.string().uuid(),
    item_attachment_id: z.string().uuid(),
    status: annotationStatusEnum,
    created: z.string(),
    modified: z.string(),
});
